import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { useTagUndoStore } from "@/stores/tag-undo";
/** Manages open/minimized state of the task detail overlay. */
export var useTaskDetailStore = create()(devtools(function (set) {
  return {
    reminder: null,
    status: "open",
    open: function open(reminder) {
      return set({
        reminder: reminder,
        status: "open"
      }, false, "open");
    },
    minimize: function minimize() {
      return set({
        status: "minimized"
      }, false, "minimize");
    },
    restore: function restore() {
      return set({
        status: "open"
      }, false, "restore");
    },
    close: function close() {
      useTagUndoStore.getState().reset();
      set({
        reminder: null,
        status: "open"
      }, false, "close");
    }
  };
}, {
  name: "TaskDetailStore",
  enabled: typeof window !== "undefined" && process.env.NODE_ENV !== "production"
}));